export const sessionTimeoutModuleName = 'session-timeout';
